import { render, staticRenderFns } from "./ViewReferrals.vue?vue&type=template&id=08a4bcc0&"
import script from "./ViewReferrals.vue?vue&type=script&lang=js&"
export * from "./ViewReferrals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports